import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { QualityOdsService } from 'src/app/services/quality-ods.service';
import * as _moment from 'moment';
import { MatDialog } from '@angular/material/dialog';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { BtnCellRendererQxMatrix } from 'src/app/btn-cell-rendererQxMatrix';
import { PDFExportRenderer } from 'src/app/pdf-export-renderer.component';

@Component({
  selector: 'app-qa-data-entry',
  templateUrl: './qa-data-entry.component.html',
  styleUrls: ['./qa-data-entry.component.scss']
})
export class QaDataEntryComponent implements OnInit {
  @ViewChild('displayCommonAttributeHistoryModal')
  private displayCommonAttributeHistoryModal!: TemplateRef<any>;
  @ViewChild('displayMaterialDataHistoryModal')
  private displayMaterialDataHistoryModal!: TemplateRef<any>;
  @ViewChild('displayPDFExportModal')
  private displayPDFExportModal!: TemplateRef<any>;
  @ViewChild(MatTable) table!: MatTable<any>;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  qaMasterForm!: FormGroup;
  reportTypes!: any[];
  crewList!: any[];
  defectList!: any[];
  shiftList!: any[];
  thicknessList!: any[];
  materialList!: any;
  lastCommonAttribute!: any;
  commonAttributeInsertedId = 0;
  commonAttributes!: any[];
  commonAttributesColumns: string[] = [
    'Id',
    'Shift',
    'Crew',
    'Quality',
    'Standard',
    'Thickness',
    'GrossWidth',
    'NetAvailable',
    'NetCut',
    'CreatedOn',
    'Actions'
  ];
  commonAttributesData!: MatTableDataSource<any>;
  isLoadingCommonAttribute = false;
  formPropertiesArray: any[] = [];
  qaDynamicForm!: FormGroup;
  isLoadingData = false;
  gridOptions: any = {
    defaultColDef: {
      filter: 'agTextColumnFilter',
      headerHeight: 50,
      floatingFilterComponentParams: {
        suppressFilterButton: false,
      },
      filterParams: { newRowsAction: 'keep' },
    },
    frameworkComponents: {
      btnCellRendererQxMatrix : BtnCellRendererQxMatrix,
    },
    paginationPageSize: 10,
  };
  gridOptionsDataHistory: any = {
    defaultColDef: {
      filter: 'agTextColumnFilter',
      headerHeight: 50,
      floatingFilterComponentParams: {
        suppressFilterButton: false,
      },
      filterParams: { newRowsAction: 'keep' },
    },
    frameworkComponents: {
      btnCellRendererQxMatrix : BtnCellRendererQxMatrix,
    },
    paginationPageSize: 10,
  };
  gridOptionsReports: any = {
    suppressPropertyNamesCheck: true,
    defaultColDef: {
      cellRenderer: "pdfExportRenderer",
      filter: 'agTextColumnFilter',
      headerHeight: 50,
      filterParams: { newRowsAction: 'keep' },
    },
    frameworkComponents: {
      pdfExportRenderer: PDFExportRenderer
    },
  };
  gridApi: any;
  gridColumnApi: any;
  columnDefs: any[] = [];
  rowData: any;
  columnDefsMaterialHistory: any[] = [];
  rowDataMaterialHistory: any;
  rowSelection: string = 'single';
  ButtonType!: any;
  ButtonTypeMaterialHistory!: any;
  isMaterialDataMode = true;
  qaDataId = 0;
  // reports properties
  isReportMode = false;
  currentDate = new Date();
  rowDataReport: any[] = [];
  columnDefsReport: any[] = [];
  rowMultiple = "multiple";
  exportExcelColumns: any[] = [];
  constructor(private fb: FormBuilder, private toaster: ToastrService,
              private qualityService: QualityOdsService, public dialog: MatDialog,
              ) { }

  ngOnInit(): void {
    this.qaMasterForm = this.fb.group({
      date: ['', Validators.required],
      reportType: ['', Validators.required],
      crew: ['', Validators.required],
      shift: ['', Validators.required],
      quality: ['', Validators.required],
      standard: ['', Validators.required],
      thickness: ['', Validators.required],
      grossWidth: ['', Validators.required],
      netAvailable: ['', Validators.required],
      netCut: ['', Validators.required]
    });
    this.getReportTypes();
    this.getBaseDetails();
  }

  getReportTypes(): void {
    this.qualityService.getReportTypes({}).subscribe(response => {
      if (response?.HasError) {
        this.toaster.error('Error', response?.ErrorMessage);
      }else {
        this.reportTypes = response?.MaterialList;
        this.qaMasterForm.get('reportType')?.setValue(this.reportTypes[0]?.TypeId);
      }
    }, (error) => {
      this.toaster.error('Error', error?.message);
    });
  }
  getBaseDetails(): void {
    const key = {
      UserId: 100001
    };
    this.qualityService.getBaseDetails(key).subscribe(response => {
      if (response?.HasError) {
        this.toaster.error('Error', response?.ErrorMessage);
      }else {
        this.crewList = response?.CrewList;
        this.defectList = response?.DefectList;
        this.shiftList = response?.ShiftList;
        this.thicknessList = response?.ThicknessList;
        this.materialList = response?.MaterialList;
        this.qaMasterForm.get('crew')?.setValue(this.crewList[0]?.TypeId);
        this.qaMasterForm.get('shift')?.setValue(this.shiftList[0].TypeId);
        this.qaMasterForm.get('thickness')?.setValue(this.thicknessList[0]?.TypeName);
        this.qaMasterForm.get('date')?.setValue(new Date());
        this.getLastCommonAttribute();
      }
    }, (error) => {
      this.toaster.error('Error', error?.message);
    });
  }

  getThicknesses(): void {
    this.qualityService.getThickness({}).subscribe(response => {
      if (response?.HasError) {
        this.toaster.error('Error', response?.ErrorMessage);
      }else {
        this.thicknessList = response?.ThicknessList;
      }
    }, (error) => {
      this.toaster.error('Error', error?.message);
    });
  }
  getLastCommonAttribute(): void {
    const key = {
      UserId: 100001
    };
    this.qualityService.getLastCommonAttribute(key).subscribe(response => {
      if (response?.HasError) {
        this.toaster.error('Error', response?.ErrorMessage);
      }else {
        this.lastCommonAttribute = response?.LastEnteredCommonAttributes[0];
        // this.qaMasterForm.get('date')?.setValue(new Date(this.lastCommonAttribute?.CreatedOn));
        this.qaMasterForm.get('quality')?.setValue(this.lastCommonAttribute?.Quality);
        this.qaMasterForm.get('standard')?.setValue(this.lastCommonAttribute?.Standard);
        this.qaMasterForm.get('grossWidth')?.setValue(this.lastCommonAttribute?.GrossWidth);
        this.qaMasterForm.get('netAvailable')?.setValue(this.lastCommonAttribute?.NetAvailable);
        this.qaMasterForm.get('netCut')?.setValue(this.lastCommonAttribute?.NetCut);
        this.qaMasterForm.get('crew')?.setValue(this.lastCommonAttribute?.CrewId);
        this.qaMasterForm.get('shift')?.setValue(this.lastCommonAttribute?.ShiftId);
        this.qaMasterForm.get('thickness')?.setValue(this.lastCommonAttribute?.Thickness);
      }
    }, (error) => {
      this.toaster.error('Error', error?.message);
    });
  }

  saveMasterEntry(): void {
    const {shift, crew, quality, standard, thickness, grossWidth,
          netAvailable, netCut, date} = this.qaMasterForm.value;
    const data = {
      ShiftId: shift,
      CrewId: crew,
      Quality: quality,
      Standard: standard,
      Thickness: thickness,
      GrossWidth: grossWidth,
      NetAvailable: netAvailable,
      NetCut: netCut,
      CreatedOn: _moment(date).format('yyyy/MM/DD')
    }
    this.qualityService.insertCommonAttribute(data).subscribe(response => {
      if (response?.HasError) {
        this.toaster.error('Error', response?.ErrorMessage);
      }else {
          this.commonAttributeInsertedId = response?.data ? response.data.Id : 0;
          this.getLastCommonAttribute();
          this.toaster.success('Success', 'Common Attributed Saved Successfully')
      }
    }, (error) => {
        this.toaster.error('Error', error?.message);
    });
  }
  getCommonAttributes(): void {
    this.isLoadingCommonAttribute = true;
    this.qualityService.getCommonAttributes({}).subscribe(response => {
      if (response?.HasError) {
        this.toaster.error('Error', response?.ErrorMessage);
      }else {
        this.commonAttributes = [];
          this.commonAttributes = response?.LastEnteredCommonAttributes?.
                        sort((a: any, b: any) => {
                          return b.Id - a.Id;
                        });
          this.commonAttributesData = new MatTableDataSource(this.commonAttributes);
          this.getPaginator();
      }
      this.isLoadingCommonAttribute = false;
    }, (error) => {
        this.toaster.error('Error', error?.message);
        this.isLoadingCommonAttribute = false;
    });
  }

  // common attributes history related section
  openCommonAttributeHistoryModel(): void {
    this.dialog.open(this.displayCommonAttributeHistoryModal, 
      {width: '100%', height: '95%', disableClose: true });
    this.getCommonAttributes()
  }

  editCommonAttribute(Id: number): void {
    const foundAttribute = this.commonAttributes.find(x => x.Id === Id);
    if (foundAttribute) {
      const {CreatedOn, Crew, GrossWidth, NetAvailable, NetCut,
            Quality, Shift, Standard, Thickness} = foundAttribute;
      this.qaMasterForm.get('date')?.setValue(new Date(CreatedOn));
      this.qaMasterForm.get('quality')?.setValue(Quality);
      this.qaMasterForm.get('standard')?.setValue(Standard);
      this.qaMasterForm.get('grossWidth')?.setValue(GrossWidth);
      this.qaMasterForm.get('netAvailable')?.setValue(NetAvailable);
      this.qaMasterForm.get('netCut')?.setValue(NetCut);
      this.qaMasterForm.get('crew')?.setValue(this.crewList.find(x => x.TypeName === Crew)?.TypeId);
      this.qaMasterForm.get('shift')?.setValue(this.shiftList.find(x => x.TypeName === Shift)?.TypeId);
      this.qaMasterForm.get('thickness')?.setValue(Thickness);
      this.dialog.closeAll();
    }
  }

  deleteCommonAttribute(Id: number): void {
    this.isLoadingCommonAttribute = true;
    this.qualityService.deleteCommonAttribute({Id}).subscribe(response => {
      if (response?.HasError) {
        this.toaster.error('Error', response?.ErrorMessage);
      }else {
          this.toaster.success('Success', 'Common Attribute Deleted Successfully');
          this.dialog.closeAll();
          this.getLastCommonAttribute();
      }
      this.isLoadingCommonAttribute = false;
    }, (error) => {
        this.toaster.error('Error', error?.message);
        this.isLoadingCommonAttribute = false;
    });
  }


  getPaginator(): void {
    setTimeout(() => {
      this.commonAttributesData.paginator = this.paginator;
      this.commonAttributesData.sort = this.sort;
    }, 1000);
  }

  applyFilter(event: any): void {
    const filterValue = (event.target as HTMLInputElement).value;
    this.commonAttributesData.filter = filterValue.trim().toLowerCase();
  }

  // reports form sections and load reports

  loadReportForm(): void {
    this.isReportMode = false;
    const typeId = this.qaMasterForm.value.reportType;
    const reportType = this.reportTypes.find(x => x.TypeId === typeId);
    if (reportType) {
      this.isLoadingData = true;
      this.isMaterialDataMode = true;
      const key = {
        ReportId: reportType.TypeId,
        ReportName: reportType.TypeName
      }
      this.qualityService.getQAProperties(key).subscribe(response => {
        if (response?.HasError) {
          this.toaster.error('Error', response?.ErrorMessage);
        }else {
          const properties: any[] = response?.QAPropertyList;
          this.formPropertiesArray = [];
          const uniqueTypes: any[] = [...new Set(properties.map((x: any) => {
            return x.Type;
          }))];
          uniqueTypes.forEach(type => {
            this.formPropertiesArray.push({
              TypeName: type,
              properties: properties.filter(x => x.Type === type)
                          ?.map(x => {
                            return {
                              Id: x.Id,
                              Name: x.Name,
                              DisplayName: x.DisplayName
                            }
                          })
            });
          });
          const formControls: any = {};
          formControls['Time'] = [new Date()];
          properties.forEach(element => {
              formControls[element?.Name] = [''];
          });
          this.qaDynamicForm = this.fb.group(formControls);
          this.getQAEntries(1);   
          this.isLoadingData = false;       
        }
      }, (error) => {
        this.isLoadingData = false;
        this.toaster.error('Error', error?.message);
      })
    }else {
      this.toaster.warning('Warning', 'Report Type Not Selected');
    }
  }

  getQAEntries(transType: number): void {
    const {reportType, date} = this.qaMasterForm.value;
    const type = this.reportTypes.find(x => x.TypeId === reportType);
    if (reportType) {
        const key = {
          ReportName: type.TypeName,
          ReportId: type.TypeId,
          TransactionType: transType,
          DateValue: _moment(date).format('yyyy/MM/DD'),
          CommonAttributeId: ''
        }
        this.qualityService.getQAEntries(key).subscribe(response => {
          if (response?.HasError) {
            this.toaster.error('Error', response?.ErrorMessage);
          }else {
            const tempColsArray: any[] = [];
            const headersArray = response?.Headers;
            const dataArray = response?.DataList;
            response?.Headers.forEach((value: string) => {
              if (value === 'Actions') {
                tempColsArray.push({                  
                    field: value,
                    headerName: value,
                    cellRenderer: 'btnCellRendererQxMatrix',
                    editable: false,
                    cellRendererParams: {
                      clicked: (field: any) => {
                      }
                    }, sortable: true, resizable: true, wrapText: true
                  }
                )
              }else {
                tempColsArray.push({
                  field: value,
                  headerName: value,
                  sortable: true, 
                  resizable: true, 
                  wrapText: true
                });                
              }
            });
            const tableData = dataArray.map((row: any[]) => {
              return row.reduce((result: { [x: string]: any; }, field: any, index: string | number) => {
                result[headersArray[index]] = field;
                return result;
              }, {});
            });
            if (transType === 1) {
              this.columnDefs = tempColsArray;
              this.rowData = tableData;
            }else {
              this.columnDefsMaterialHistory = tempColsArray;
              this.rowDataMaterialHistory = tableData;
            }
          }
        }, (error) => {
          this.rowData = [];
          this.rowDataMaterialHistory = [];
          this.toaster.error('Error', error?.message);
        })
     }
  }

  cellClicked(params: any): void {
    const col = params.colDef.field;
    const id = params.data.Id;
    this.ButtonType = '';
    if (col === 'Actions') {
      this.ButtonType = params.event.target.textContent;
      if (this.ButtonType === 'edit') {
       console.log('Edit Clicked' + id);
       this.isMaterialDataMode = false;
       this.qaDataId = id;
       const rowObj = params.data;
       for (const key in rowObj) {
         if (Object.prototype.hasOwnProperty.call(rowObj, key)) {
          this.qaDynamicForm.get(key)?.setValue(rowObj[key]); 
         }
       }
       this.dialog.closeAll();
       
      }
      else if (this.ButtonType === 'delete') {
        this.ButtonType = '';
        const {reportType} = this.qaMasterForm.value;
        const type = this.reportTypes.find(x => x.TypeId === reportType);
        if (type) {
          const key = {
            Id: id,
            ReportName: type.TypeName,
            TransactionType: 5
          }
          this.qualityService.deleteQAData(key).subscribe(response => {
            if (response?.HasError) {
              this.toaster.error('Error', response?.ErrorMessage);
            }else {
                this.toaster.success('Success', 'QA Data Deleted Successfully');
                this.dialog.closeAll();
                this.getQAEntries(1);
            }
            this.isLoadingCommonAttribute = false;
          }, (error) => {
              this.toaster.error('Error', error?.message);
              this.isLoadingCommonAttribute = false;
          });
        }else {
          this.toaster.error('Error', 'Please Select Report Type First');
        }
      }

    }
  }
  cellClickedMaterialHistory(params: any): void {
    const col = params.colDef.field;
    const id = params.data.Id;
    this.ButtonTypeMaterialHistory = '';
    if (col === 'Actions') {
      this.ButtonTypeMaterialHistory = params.event.target.textContent;
      if (this.ButtonTypeMaterialHistory === 'edit') {
       this.isMaterialDataMode = false;
       this.qaDataId = id;
       const rowObj = params.data;
       for (const key in rowObj) {
         if (Object.prototype.hasOwnProperty.call(rowObj, key)) {
          this.qaDynamicForm.get(key)?.setValue(rowObj[key]); 
         }
       }
       this.dialog.closeAll();       
      }
      else if (this.ButtonTypeMaterialHistory === 'delete') {
        this.ButtonTypeMaterialHistory = '';
        const {reportType} = this.qaMasterForm.value;
        const type = this.reportTypes.find(x => x.TypeId === reportType);
        if (type) {
          const key = {
            Id: id,
            ReportName: type.TypeName,
            TransactionType: 5
          }
          this.qualityService.deleteQAData(key).subscribe(response => {
            if (response?.HasError) {
              this.toaster.error('Error', response?.ErrorMessage);
            }else {
                this.toaster.success('Success', 'QA Data Deleted Successfully');
                this.dialog.closeAll();
                this.getQAEntries(1);
            }
            this.isLoadingCommonAttribute = false;
          }, (error) => {
              this.toaster.error('Error', error?.message);
              this.isLoadingCommonAttribute = false;
          });
        }else {
          this.toaster.error('Error', 'Please Select Report Type First');
        }
      }

    }
  }

  saveQAData(): void {
    const formValueObj = this.qaDynamicForm.value;
    const dataList: any[] = [];
    for (const key in formValueObj) {
      if (Object.prototype.hasOwnProperty.call(formValueObj, key) && key !== 'Time') {
        dataList.push({
          Name: key,
          Value: formValueObj[key]
        });        
      }
    }
    const {reportType, shift, crew, quality, standard, thickness, grossWidth,
      netAvailable, netCut, date} = this.qaMasterForm.value;
    const type = this.reportTypes.find(x => x.TypeId === reportType);
    if (type) {
      const data = {
        Quality: quality,
        Standard: standard,
        Thickness: thickness,
        GrossWidth: grossWidth,
        NetAvailable: netAvailable,
        NetCut: netCut,
        ReportId: type?.TypeId,
        ReportName: type?.TypeName,
        CrewId: crew,
        ShiftId: shift,
        UserId: 100001,
        QADataList: dataList,
        CreatedOn: _moment(date).format('yyyy/MM/DD HH:mm') 
      }
      this.qualityService.insertQAData(data).subscribe(response => {
        if (response?.HasError) {
          this.toaster.error('Error', response?.ErrorMessage);
        }else {
            this.getQAEntries(1);
            this.toaster.success('Success', 'QA Data Saved Successfully')
        }
      }, (error) => {
          this.toaster.error('Error', error?.message);
      });
    }else {
      this.toaster.error('Error', 'Please Select Report Type First');
    }
  }

  updateQAData(): void {
    const formValueObj = this.qaDynamicForm.value;
    const dataList: any[] = [];
    for (const key in formValueObj) {
      if (Object.prototype.hasOwnProperty.call(formValueObj, key) && key !== 'Time') {
        dataList.push({
          Name: key,
          Value: formValueObj[key]
        });        
      }
    }
    const {reportType, shift, crew, quality, standard, thickness, grossWidth,
      netAvailable, netCut, date} = this.qaMasterForm.value;
    const type = this.reportTypes.find(x => x.TypeId === reportType);
    if (type) {
      const data = {
        Quality: quality,
        Standard: standard,
        Thickness: thickness,
        GrossWidth: grossWidth,
        NetAvailable: netAvailable,
        NetCut: netCut,
        ReportId: type?.TypeId,
        ReportName: type?.TypeName,
        CrewId: crew,
        ShiftId: shift,
        UserId: 100001,
        QADataList: dataList,
        UpdatedOn: _moment(date).format('yyyy/MM/DD HH:mm'),
        UpdateId: this.qaDataId 
      }
      this.qualityService.updateQAData(data).subscribe(response => {
        if (response?.HasError) {
          this.toaster.error('Error', response?.ErrorMessage);
        }else {
            this.getQAEntries(1);
            this.toaster.success('Success', 'QA Data Saved Successfully')
            this.isMaterialDataMode = true;
            this.qaDataId = 0;
        }
      }, (error) => {
          this.toaster.error('Error', error?.message);
      });
    }else {
      this.toaster.error('Error', 'Please Select Report Type First');
    }

  }

  openMaterialDataHistoryModel(): void {
    this.dialog.open(this.displayMaterialDataHistoryModal, 
      {width: '100%', height: '95%', disableClose: true });
      this.getQAEntries(2);
  }

  onGridReady(params: any): any {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  // reports section 

  getReports(): void {
    this.isReportMode = true;
    const {reportType, date} = this.qaMasterForm.value;
    const type = this.reportTypes.find(x => x.TypeId === reportType);
    if (reportType) {
        const key = {
          ReportName: type.TypeName,
          ReportId: type.TypeId,
          TransactionType: 2,
          DateValue: _moment(date).format('yyyy/MM/DD')
        }
        this.qualityService.getQAReport(key).subscribe(response => {
          if (response?.HasError) {
            this.toaster.error('Error', response?.ErrorMessage);
          }else {
            const tempColsArray: any[] = [];
            const headersArray = response?.Headers;
            const dataArray = response?.DataList;
            this.exportExcelColumns = response?.Headers;
            tempColsArray.push({
              headerCheckboxSelection: true,
              checkboxSelection: true,
              colId: 'selection-col',
              maxWidth: 50,
              pdfExportOptions: {
                skipColumn: true,
              },
            });
            response?.Headers.forEach((value: string) => {
                if (value === 'NAME') {
                  tempColsArray.push({
                    field: value,
                    headerName: value
                  })
                  
                }else {
                  tempColsArray.push({
                    field: value,
                    headerName: value,
                    sortable: true, 
                    resizable: true, 
                    wrapText: true
                  });
                }           
            });
            const tableData = dataArray.map((row: any[]) => {
              return row.reduce((result: { [x: string]: any; }, field: any, index: string | number) => {
                result[headersArray[index]] = field;
                return result;
              }, {});
            });
            this.columnDefsReport = tempColsArray;
            this.rowDataReport = tableData;
          }
        }, (error) => {
          this.rowData = [];
          this.rowDataMaterialHistory = [];
          this.toaster.error('Error', error?.message);
        })
     }
  }

  onFirstDataRendered(params: { columnApi: { autoSizeAllColumns: () => void; }; }) {
    params.columnApi.autoSizeAllColumns();
  }

  onColumnEverythingChanged(params: { columnApi: { getColumn: (arg0: string) => any; moveColumn: (arg0: any, arg1: number) => void; }; }) {
    let selectionCol = params.columnApi.getColumn("selection-col");
    if (selectionCol) {
      params.columnApi.moveColumn(selectionCol, 0);
    }
  }

  exportToExcel(): void {
    const excelParams = {
      headerRowHeight: 50,
      sheetName: 'Physical - QA Report',
      fileName: 'Physical - QA Report',
      allColumns: false,
      columnKeys: this.exportExcelColumns
    }
    this.gridApi.exportDataAsExcel(excelParams);
  }

  openPDFExportModel(): void {
    this.dialog.open(this.displayPDFExportModal, {height: '60%', width: '50%'})
  }

}
